import React from 'react';
import * as S from './styles';
import { IconCheckmark } from '@veneer/core';
import { useTranslationHelper } from 'src/contexts/dependencyManager/utils';

interface ActionItemsListProps {
  orderNumber: string;
}

const ActionItemsList: React.FC<ActionItemsListProps> = ({ orderNumber }) => {
  const getText = useTranslationHelper();

  const handleManagePlan = () => {
    console.log('Navigate to manage HP All-In plan');
  };

  return (
    <S.ActionsList>
      <S.ActionItems>
        <S.ActionItem>
          <S.ActionIcon>
            <IconCheckmark />
          </S.ActionIcon>
          <S.ActionContent>
            <S.ActionTitle>
              {getText('confirmation.orderNumber', 'Order Number:')}
            </S.ActionTitle>
            <S.OrderValue>{orderNumber}</S.OrderValue>
          </S.ActionContent>
        </S.ActionItem>

        <S.ActionItem>
          <S.ActionIcon>
            <IconCheckmark />
          </S.ActionIcon>
          <S.ActionContent>
            <S.ActionTitle>
              {getText('confirmation.managePlan', 'Manage your')}
            </S.ActionTitle>
            <S.ActionLink onClick={handleManagePlan}>
              {getText('confirmation.managePlanLink', 'HP All-In plan')}
            </S.ActionLink>
          </S.ActionContent>
        </S.ActionItem>
      </S.ActionItems>

      <S.EmailNotification>
        {getText(
          'confirmation.emailNotification',
          'A confirmation email and further details will be sent to you.'
        )}
      </S.EmailNotification>
    </S.ActionsList>
  );
};

export default ActionItemsList;
